import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  author?: string;
  robots?: string;
  canonicalUrl?: string;
}

export const SEO = ({
  title = "monelab",
  description = "Sistema inteligente de controle financeiro pessoal com relatórios avançados, categorização automática e insights baseados em IA para melhor gestão das suas finanças.",
  keywords = "controle financeiro, finanças pessoais, gestão financeira, orçamento, despesas, receitas, relatórios financeiros, IA financeira",
  image = "https://nnkflbvonjnxqzqzxmdk.supabase.co/storage/v1/object/public/lovable-uploads/d648554c-cdd1-48c0-a380-3da306bed693.png",
  url = window.location.href,
  type = "website",
  author = "monelab",
  robots = "index, follow",
  canonicalUrl = window.location.href
}: SEOProps) => {
  const fullTitle = title === "monelab" ? title : `${title} - monelab`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="monelab" />
      <meta property="og:locale" content="pt_BR" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      <meta property="twitter:site" content="@financecontrol" />
      
      {/* Additional SEO */}
      <meta name="theme-color" content="#0ea5e9" />
      <meta name="msapplication-TileColor" content="#0ea5e9" />
      <meta name="application-name" content="monelab" />
      
      {/* Structured Data - SoftwareApplication */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "monelab",
          "description": description,
          "url": url,
          "applicationCategory": "FinanceApplication",
          "operatingSystem": "Web Browser",
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "BRL"
          },
          "author": {
            "@type": "Organization",
            "name": "monelab"
          },
          "screenshot": image,
          "featureList": [
            "Controle de receitas e despesas",
            "Relatórios financeiros detalhados",
            "Categorização automática de transações",
            "Dashboard com insights inteligentes",
            "Gestão de contas e centros de custo",
            "Análise de fluxo de caixa"
          ]
        })}
      </script>
      
      {/* Organization Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "monelab",
          "url": url,
          "logo": image,
          "description": "Plataforma inteligente para gestão financeira pessoal",
          "sameAs": []
        })}
      </script>
      
      {/* WebSite Schema with Search Action */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "monelab",
          "url": url,
          "description": description,
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint",
              "urlTemplate": `${url}/transacoes?search={search_term_string}`
            },
            "query-input": "required name=search_term_string"
          }
        })}
      </script>
    </Helmet>
  );
};